import { render, staticRenderFns } from "./LegacySortDialog.vue?vue&type=template&id=29a32e9f&scoped=true&"
import script from "./LegacySortDialog.vue?vue&type=script&lang=js&"
export * from "./LegacySortDialog.vue?vue&type=script&lang=js&"
import style0 from "./LegacySortDialog.vue?vue&type=style&index=0&id=29a32e9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a32e9f",
  null
  
)

export default component.exports